import React, {useEffect, useState} from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import LoginWithFlightInformation from '../LoginPage/LoginWithFlightInformation';
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardTwoButtons from "../../component/base/onboard-two-buttons-component/OnboardTwoButtons";
import {defaultValue} from "../../store/UserStore";
import OnboardSlider from "../../component/base/onboard-slider-component/OnboardSlider";
import MilesAndSmilesLoginComponent from "../../component/custom/MilesAndSmilesLoginComponent";
import OnboardTabs from "../../component/base/onboard-tabs-component/OnboardTabs";
import LoginWithMobilApp from "./LoginWithMobilApp";
import {isMobilApp} from "../../store/AgentStore";
import option1 from 'assets/images/login/login-option-1.svg';
import option2 from 'assets/images/login/login-option-2.svg';
import option3 from 'assets/images/login/login-option-3.svg';
import {setSimulationNumber} from '../../util/SimulationManager';
import {useRecoilValue} from 'recoil';
import {informationAtom} from '../../store/InformationStore';

const LoginPage = (props) => {
    const {t, navigate, location, user, setUser, flight, handleInformation} = props.props;
    const information = useRecoilValue(informationAtom);
    const simulationNumber = setSimulationNumber();
    const [visibleTabs, setVisibleTabs] = useState(location.state === "msregister" ? 2 : 1);

    const handleChangeTab = (tab) => {
        setVisibleTabs(tab);
        setChangeTabSimulationNumber(tab);
        handleInformation("login_type_" + tab);
    }

    useEffect(() => {
        let memberId = user.memberId;
        setUser({...defaultValue, memberId: memberId});
        setFirstOpenSimulationNumber();
        handleInformation("login_type_1");
    }, []);

    const setFirstOpenSimulationNumber = () => {
        if (information.simulationStep === 1) {
            simulationNumber(2, 1);
        } else if (information.simulationStep === 3 && information.simulationNumber === 1) {
            simulationNumber(2, 3);
        } else if (information.simulationStep === 3 && information.simulationNumber === 4) {
            simulationNumber(5, 3);
        } else if (information.simulationStep === 3 && information.simulationNumber === 7) {
            simulationNumber(8, 3);
        } else if (information.simulationStep === 4 && information.simulationNumber === 10) {
            simulationNumber(11, 4);
        }
    }

    const setChangeTabSimulationNumber = (tab) => {
        if (information.simulationStep === 1) {
            if (tab === 1) {
                if (information.simulationNumber === 11)
                    simulationNumber(12, 1);
            } else if (tab === 2) {
                simulationNumber(10, 1);
            } else if (tab === 3) {
                simulationNumber(11, 1);
            }
        }
        if (information.simulationStep === 3) {
            if (tab === 2) {
                if (information.simulationNumber === 5) {
                    simulationNumber(6, 3);
                } else if (information.simulationNumber === 8) {
                    simulationNumber(9, 3);
                }
            }
        }
    }

    return (
        <div>
            <HeaderComponent title={t('login.title')}
                             content={flight.domestic ? t('login.content_domestic') : t('login.content')}/>

            <div className="content-root">

                <p className="login-options">{t('login.enter_options')}</p>

                <OnboardTabs onChange={(e) => handleChangeTab(e)}
                             defaultActiveTab={visibleTabs}
                             tabs={[
                                 {key: 1, label: t('login.tabs.option_flightinfo'), icon: option1},
                                 {key: 2, label: t('login.tabs.option_milesandsmiles'), icon: option2},
                                 {key: 3, label: t('login.tabs.option_mobilapp'), icon: option3, onlyShowMobil: true},
                             ]}
                />

                <div className="login-input-area">

                    {visibleTabs === 1 && (
                        <LoginWithFlightInformation props={props.props}/>
                    )}

                    {visibleTabs === 2 && (
                        <MilesAndSmilesLoginComponent props={props.props}/>
                    )}

                    {visibleTabs === 3 && isMobilApp() && <LoginWithMobilApp props={props.props}/>}

                    <OnboardButton outline label={t('login.sign_up_miles_smiles')}
                                   onClick={() => navigate('/miles-and-smiles-register', {state: "login"})}/>

                </div>

                <div className="h-12"/>

                <OnboardTwoButtons leftLabel={t('login.free_internet_rights')}
                                   rightLabel={t('login.internet_packages')}
                                   onClickLeft={() => navigate("/free-internet-rights")}
                                   onClickRight={() => navigate("/internet-packages")}/>

                <div className="h-12"/>

                <OnboardButton gray label={t('login.tabs.gift_coupon_code')}
                               onClick={() => navigate("/login-other")}/>

                <OnboardButton gray label={t('feedback.evaluate_our_internet_service')}
                               onClick={() => navigate('/feedback', {state: 'login'})}/>

                <OnboardSlider/>

            </div>

            <FooterComponent/>

        </div>
    );
};

export default LoginPage;

